export const PRICES = [
    1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000,
    15000, 20000, 25000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000,
];

export const GEARBOX_TYPES = [
    {id: "automatic", name: "Automatic"},
    {id: "manual", name: "Manual"},
    {id: "semi-automatic", name: "Semi-Automatic"},
    {id: "unlisted", name: "Unlisted"},
];

export const DOORS = [
    "0", "1", "2", "3", "4", "5", "6",
];

export const DISTANCES = [
    1, 5, 10, 15, 20, 25, 30, 40, 50, 55, 60, 70, 80, 90, 100, 200
];

export const SORT_BY_FIELDS = [
    {id: "latest-cars", field: "first-seen-at", name: "Most Recent"},
    {id: "price", field: "price", name: "Price (lowest)"},
    {id: "price-desc", field: "price", name: "Price (highest)", desc: true},
    {id: "distance", field: "distance", name: "Distance"},
    {id: "manufacturer", field: "manufacturer", name: "Mileage"},
    {id: "year", field: "year", name: "Age"},
];
